import type { ReactNode, RefCallback } from 'react'

interface Props {
  activationRef: RefCallback<HTMLDivElement>
  children: ReactNode
}

function StructuredFacilitiesReworkActivation({ activationRef, children }: Props) {
  return <div ref={activationRef}>{children}</div>
}

export default StructuredFacilitiesReworkActivation
